import angular from 'angular';
import { MeurhAdmissoesValetransportepersonalizadoFormmodalController } from './valetransportepersonalizado.formmodal.controller';

export class MeurhAdmissoesValetransportepersonalizadoFormmodalComponent implements angular.IComponentOptions {
	static selector = 'meurhAdmissoesValetransportepersonalizadoFormmodalComponent';
	static controller = MeurhAdmissoesValetransportepersonalizadoFormmodalController;
	static template = require('!!html-loader!./valetransportepersonalizado.formmodal.html');
	static transclude = true;
	static bindings = {
		valetransportepersonalizado: '=',
		form: '<',
		busy: '=',
		action: '<',
	};
}
